export const GetUnitFactorFromMetafields = (metafields) => {
    let sb_factor = 1;
    let sb_unit = 'PCE';
    const sb_p = metafields === null || metafields === void 0 ? void 0 : metafields['SB-P'];
    if (sb_p) {
        if (sb_p['DisplayConversionFactor']) {
            sb_factor = parseFloat(sb_p['DisplayConversionFactor']);
            sb_unit = sb_p['DisplayUnit'];
        }
        else if (sb_p['DefaultConversionFactor']) {
            sb_factor = parseFloat(sb_p['DefaultConversionFactor']);
            sb_unit = sb_p['DefaultUnit'];
        }
    }
    return { sb_factor, sb_unit };
};
export const GetUnitFactorFromMetafieldsList = (metafields) => {
    var _a;
    const metafieldKeyValues = (_a = metafields.reduce((r, c) => {
        if (!c.namespace || !c.key) {
            return r;
        }
        r[c.namespace] = r[c.namespace] || {};
        return Object.assign(Object.assign({}, r), { [c.namespace]: Object.assign(Object.assign({}, r[c.namespace]), { [c.key]: c.value }) });
    }, {})) !== null && _a !== void 0 ? _a : {};
    return GetUnitFactorFromMetafields(metafieldKeyValues);
};
